import React from 'react';

export const NewMexicoInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of New Mexico</p>
        <p className="eds-l-mar-bot-1">
            <strong>Business Loan Guarantee Program</strong> |&nbsp;
            <a
                href="https://gonm.biz/about-us/covid-19-response"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>Loan or line of credit up to 80% of principal or $50,000.</p>
    </div>
);
